const withdrawnPatientStatuses = Object.freeze([
  'Pre-screen Failed',
  'Run In Failed',
  'Screen Failed',
  'Withdrawn',
  'Canceled',
  'Early Termination'
]);
export default withdrawnPatientStatuses;
